import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import Login from '@/components/Login'
import Home from '@/components/Home'
import List from '@/components/List'
import ListOrder from '@/components/ListOrder'
import ListDetails from '@/components/ListDetails'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home
    },
    {
      path: '/List',
      name: 'List',
      component: List
    },
    {
      path: '/ListDetails',
      name: 'ListDetails',
      component: ListDetails
    },
    {
      path: '/ListOrder',
      name: 'ListOrder',
      component: ListOrder
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js